import axios from '../axios'
import qs from "qs";

function service(endpoint) {

    function copy(id, data = {}) {
        return axios.get(`${endpoint}/${id}/copy`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    function createFromNewsletter(id, data = {}) {
        return axios.post(`newsletters/newsletters/${id}/settings`, data).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        copy,
        createFromNewsletter
    }
}

export default service
